import {
  FieldWrapper,
  type FieldWrapperProps,
} from '../../components/field-wrapper/FieldWrapper';
import { Input } from '../../components/input';
import { Box } from '@terra/ui-styled-system';
import { EyeIcon, ViewOffIcon } from '@terra/ui-icons';
import { automationId } from '@terra/shared-utils';
import { useState } from 'react';

export type PasswordFieldProps = Omit<FieldWrapperProps, 'children'> & {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  hidePasswordToggle?: boolean;
  dataTestid?: string;
};

export const PasswordField = ({
  label,
  helperText,
  isRequired,
  error,
  placeholder,
  value,
  onChange,
  hidePasswordToggle,
  dataTestid,
}: PasswordFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputType = hidePasswordToggle || !showPassword ? 'password' : 'text';
  const Icon = showPassword ? ViewOffIcon : EyeIcon;

  return (
    <FieldWrapper
      label={label}
      helperText={helperText}
      isRequired={isRequired}
      error={error}
    >
      <Box position="relative">
        <Input
          size="sm"
          placeholder={placeholder}
          type={inputType}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          pr={hidePasswordToggle ? undefined : '8'}
          {...(dataTestid ? automationId(dataTestid) : {})}
        />
        {!hidePasswordToggle && (
          <Icon
            size={16}
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: 'var(--spacing-2)',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          />
        )}
      </Box>
    </FieldWrapper>
  );
};
